import React from 'react';
import styled from 'styled-components';

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px 0 20px;
  height: 50px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  flex-shrink: 0;
`;

const Title = styled.h3`
  font-family: 'Poppins'
  margin: 0;
  font-size: 1.5rem;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  color: #6c757d;
  padding: 5px;

  &:hover {
    color: #212529;
  }
`;

const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;


const PanelHeader = ({ title, showCloseButton, onClose, children }) => {
  return (
    <HeaderWrapper>
      <Title title={title}>{title}</Title>
      <ActionsContainer>
        {children}
        {showCloseButton && (
          <CloseButton onClick={onClose} aria-label="Close Panel">&times;</CloseButton>
        )}
      </ActionsContainer>
    </HeaderWrapper>
  );
};

export default PanelHeader;